import { EDIT_USER_BIO, SET_AVAILABLE_COINS, SET_AVAILABLE_COINS_COLLEGE, SET_MOBILE_NUMBER, SET_PROFILE_DETAILS, SHAUN_ELLIS_TEST, NPS_TEST, RESET_NPS_DATA, RESET_SE_DATA, SET_WALKTHROUGH_DATA,SET_IS_RECRUITER_FORM_OPEN  } from "../actions/types";

export default function (state = [], action) {
    switch (action.type) {
        case SET_PROFILE_DETAILS:
            return {
                ...state,
                ...action['payload']
            }
        case SET_MOBILE_NUMBER:
            return {
                ...state,
                ['phone-number']: action.payload.phone_number,
                number_verification: action.payload.verified
            }
        case EDIT_USER_BIO:
            return {
                ...state,
                bio: action.payload
            }
        case SET_AVAILABLE_COINS:
            return {
                ...state, user_coins_data: [{
                    ...state?.user_coins_data?.[0], ['available-coins']: action.payload
                }]
            }
        case SET_AVAILABLE_COINS_COLLEGE:
            return {
                ...state, user_college: { ...state.user_college, coin_quota: { ...state.user_college.coin_quota, current_coins: action.payload } }
            }
        case SHAUN_ELLIS_TEST:
            return { ...state, shaunEllisAnalytics: action.payload.analytics, shaunEllisResponse: action.payload }
        case NPS_TEST:
            return { ...state, NPSResponse: action.payload }
        case RESET_NPS_DATA:
            return { ...state, NPSResponse: null }
        case RESET_SE_DATA:
            return { ...state, shaunEllisResponse: null }
        case SET_WALKTHROUGH_DATA:
            return {
                ...state, walkthrough: action.payload
            }
        case SET_IS_RECRUITER_FORM_OPEN:
            return {
                ...state, isRecruiterFormOpen: action.payload
            }
        default:
            return state;
    }
}